import { render, staticRenderFns } from "./FaqView.vue?vue&type=template&id=460a058f&scoped=true"
import script from "./FaqView.vue?vue&type=script&lang=js"
export * from "./FaqView.vue?vue&type=script&lang=js"
import style0 from "./FaqView.vue?vue&type=style&index=0&id=460a058f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a058f",
  null
  
)

export default component.exports